module.exports = __webpack_public_path__ + "img/CNAS.bb4183d1.png";